import React from 'react';
import { Helmet } from 'react-helmet';

const TitleTag = (props) => {
  const title = props.title;
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  )
}

TitleTag.defaultProps={
  title:"",
}

export default TitleTag;
